import {
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { environment } from '../../environments/environment';

export const attachXAPIKeyInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
) => {
  const clonedReq = req.clone({
    headers: req.headers.set('x-api-key', environment.x_api_key),
  });

  return next(clonedReq);
};
